import { Brick, registerBrick } from 'olympe';

export default class AddExtraParams extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Object} initialObj
     * @param {!Map} extraParams
     * @param {function(*)} setOutputObj
     */
    update($, [initialObj, extraParams], [setOutputObj]) {
        for (const [key, value] of extraParams.entries()) {
            if (key && value) {
                if (Array.isArray(value) && value.length > 0) {
                    const graphUrl = `https://graph.microsoft.com/v1.0/users`;
                    const newValue = value.map(element => `${graphUrl}/${element}`);
                    initialObj[key] = newValue;
                } else {
                    initialObj[key] = value;
                }
            } else if (key) {
                initialObj[key] = "";
            }
        }
        setOutputObj(initialObj);
    }

}

registerBrick('018f99d4e1c6cff49226', AddExtraParams);
